<template>
  <svg viewBox="0 0 10 13" xmlns="http://www.w3.org/2000/svg">
    <title>Restart icon</title>
    <path d="M5.0026 2.91536V0.582031L2.08594 3.4987L5.0026 6.41536V4.08203C6.93344 4.08203 8.5026 5.6512 8.5026 7.58203C8.5026 9.51286 6.93344 11.082 5.0026 11.082C3.07177 11.082 1.5026 9.51286 1.5026 7.58203H0.335938C0.335938 10.1604 2.42427 12.2487 5.0026 12.2487C7.58094 12.2487 9.66927 10.1604 9.66927 7.58203C9.66927 5.0037 7.58094 2.91536 5.0026 2.91536Z"/>
  </svg>

</template>

<script>
export default {
  name: 'KIconRestart'
}
</script>
